/* mx-chat — atendimento MoxLand (leva para o WhatsApp) */
(function () {
  if (window.__mxChatInit) return;
  window.__mxChatInit = true;
  var raiz = document.querySelector('[data-mx-chat]');
  if (!raiz) return;

  var painel = raiz.querySelector('[data-mx-chat-painel]');
  var bolha = raiz.querySelector('[data-mx-chat-bolha]');
  var fone = (raiz.getAttribute('data-fone') || '')
    .replace(/\D/g, '');

  /* 0=dom 1=seg ... 6=sab | [inicio, fim] */
  var HORARIO = {
    1: [11, 19], 2: [11, 19], 3: [11, 19], 4: [11, 19],
    5: [11, 20], 6: [11, 17]
  };
  function aberto() {
    var agora = new Date();
    var faixa = HORARIO[agora.getDay()];
    if (!faixa) return false;
    var h = agora.getHours();
    return h >= faixa[0] && h < faixa[1];
  }

  function marcarStatus() {
    var el = raiz.querySelector('[data-mx-chat-status]');
    if (!el) return;
    var on = aberto();
    el.textContent = on
      ? (raiz.getAttribute('data-txt-on') || 'Online agora')
      : (raiz.getAttribute('data-txt-off') ||
         'Fora do horário — respondemos assim que abrirmos');
    el.classList.toggle('is-on', on);
  }

  function abrir(sim) {
    raiz.classList.toggle('is-aberto', sim);
    painel.setAttribute('aria-hidden', sim ? 'false' : 'true');
    if (sim) marcarStatus();
    try {
      sessionStorage.setItem('mxChatVisto', '1');
    } catch (e) { /* ignora */ }
  }

  bolha.addEventListener('click', function () {
    abrir(!raiz.classList.contains('is-aberto'));
  });
  var fechar = raiz.querySelector('[data-mx-chat-fechar]');
  if (fechar) {
    fechar.addEventListener('click', function () { abrir(false); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') abrir(false);
  });

  /* respostas rápidas */
  raiz.addEventListener('click', function (e) {
    var t = e.target.closest ?
      e.target.closest('[data-mx-chat-item]') : null;
    if (!t) return;
    var corpo = t.parentNode.querySelector(
      '[data-mx-chat-resposta]');
    if (!corpo) return;
    e.preventDefault();
    var abertoJa = t.getAttribute('aria-expanded') === 'true';
    Array.prototype.forEach.call(
      raiz.querySelectorAll('[data-mx-chat-item]'),
      function (o) {
        o.setAttribute('aria-expanded', 'false');
        var c = o.parentNode.querySelector(
          '[data-mx-chat-resposta]');
        if (c) c.style.display = 'none';
      });
    if (!abertoJa) {
      t.setAttribute('aria-expanded', 'true');
      corpo.style.display = 'block';
    }
  });

  /* whatsapp com mensagem pronta */
  Array.prototype.forEach.call(
    raiz.querySelectorAll('[data-mx-zap]'),
    function (a) {
      var msg = a.getAttribute('data-mx-zap') ||
        'Olá! Vim pelo site da MoxLand.';
      var pag = window.location.href;
      a.setAttribute('href',
        'https://wa.me/' + fone + '?text=' +
        encodeURIComponent(msg + '\n\n' + pag));
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });

  /* rastreio: leva para a tela de pedidos com o e-mail pronto */
  var btnPedido = raiz.querySelector('[data-mx-pedido-ir]');
  if (btnPedido) {
    btnPedido.addEventListener('click', function () {
      var num = (raiz.querySelector('[data-mx-pedido-num]')
        .value || '').trim().replace(/^#/, '');
      var aviso = raiz.querySelector('[data-mx-pedido-aviso]');
      if (!num) {
        aviso.textContent = 'Digite o número do pedido.';
        return;
      }
      aviso.textContent = '';
      try {
        sessionStorage.setItem('mxPedido', num);
      } catch (e) { /* ignora */ }
      window.location.href =
        raiz.getAttribute('data-conta') || '/account';
    });
  }

  marcarStatus();
  setInterval(marcarStatus, 60000);
})();

/* mx-recesso — MoxLand (31/10/2026)
   =================================================================
   Loja em recesso: tarja, botao de comprar desligado, carrinho sem
   finalizar e captura de e-mail no lugar do botao.

   A JANELA ESTA' AQUI DENTRO, em milissegundos de UTC: ele liga e
   desliga sozinho, sem ninguem rodar nada.  Fora da janela este
   arquivo nao faz absolutamente nada.

   Nada e' despublicado: pagina no ar, preco visivel, so' sem comprar.
   =================================================================*/
(function () {
  if (window.__mxRecesso) return;
  window.__mxRecesso = true;

  var INICIO = 1794279600000;
  var FIM    = 1795575600000;
  var TARJA  = 'Estamos em recesso de 10 a 24 de novembro. Os pedidos voltam a ser enviados a partir do dia 25.';
  var BOTAO  = 'Loja em recesso — voltamos dia 25';
  var ETIQ   = 'recesso-11-2026';

  /* ⭐ PREVIA (31/10, pedido dele: "nao quero rodar ainda, muito cedo,
     pessoas verao as funcoes do recesso").  Com ?mx_recesso=ver o
     recesso liga SO' para quem abriu esse endereco, mesmo fora da
     janela — o cliente que entra pela porta normal nao ve' nada.
     Fica guardado na aba (sessionStorage) para ele poder navegar pela
     loja inteira conferindo, e sai com ?mx_recesso=sair ou fechando a
     aba.  Assim ele aprova a aparencia hoje sem expor a loja. */
  var previa = false;
  var busca = String(window.location.search || '');
  try {
    if (busca.indexOf('mx_recesso=ver') >= 0) {
      sessionStorage.setItem('mxRecessoVer', '1');
      previa = true;
    } else if (busca.indexOf('mx_recesso=sair') >= 0) {
      sessionStorage.removeItem('mxRecessoVer');
    } else {
      previa = sessionStorage.getItem('mxRecessoVer') === '1';
    }
  } catch (e) {
    previa = busca.indexOf('mx_recesso=ver') >= 0;
  }

  var agora = new Date().getTime();
  /* fora do recesso e sem previa: este arquivo nao faz nada */
  if (!previa && (agora < INICIO || agora >= FIM)) return;

  /* ⭐ A TRAVA QUE IMPORTA, e que eu quase deixei de fora (ele
     perguntou "e a compra por lista?" e tinha razao).

     A pagina /pages/compra-por-lista nao usa o formulario normal: o
     mx-lista.js manda por fetch() para /cart/add.js.  Desligar botao
     nao resolve nada ali — o cliente colava o deck e comprava no meio
     do recesso.  Entao eu barro no caminho da REDE, que cobre a lista,
     a compra rapida, o carrinho ajax e qualquer coisa que o tema
     invente depois.

     Devolvo um 422 com 'description', que e' o formato de erro do
     proprio Shopify: assim a propria tela da lista mostra o meu aviso
     no lugar onde ela ja' mostra os erros dela. */
  var PROIBIDO = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  var AVISO = 'Loja em recesso. Voltamos a enviar dia 25 — '
    + 'deixe seu e-mail na pagina que avisamos na volta.';

  function metodoDe(url, opc) {
    var m = (opc && opc.method) || (url && url.method) || 'GET';
    return String(m).toUpperCase();
  }

  function enderecoDe(url) {
    if (typeof url === 'string') return url;
    return (url && (url.url || url.href)) || '';
  }

  if (typeof window.fetch === 'function' && !window.__mxRecessoRede) {
    window.__mxRecessoRede = true;
    var fetchOriginal = window.fetch;
    window.fetch = function (url, opc) {
      try {
        if (metodoDe(url, opc) !== 'GET'
            && PROIBIDO.test(enderecoDe(url))) {
          var corpo = JSON.stringify({ status: 422,
            message: 'Loja em recesso', description: AVISO });
          if (typeof Response === 'function') {
            return Promise.resolve(new Response(corpo, { status: 422,
              headers: { 'Content-Type': 'application/json' } }));
          }
          return Promise.reject(new Error(AVISO));
        }
      } catch (e) { /* na duvida, deixo passar para nao quebrar a loja */ }
      return fetchOriginal.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest && !window.__mxRecessoXhr) {
    window.__mxRecessoXhr = true;
    var abrirOriginal = XMLHttpRequest.prototype.open;
    var enviarOriginal = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (metodo, endereco) {
      this.__mxBarrado = String(metodo || '').toUpperCase() !== 'GET'
        && PROIBIDO.test(String(endereco || ''));
      return abrirOriginal.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__mxBarrado) return;   /* nao mando: nada e' adicionado */
      return enviarOriginal.apply(this, arguments);
    };
  }

  var CSS = ''
    + '.mx-rec-tarja{background:#111;color:#fff;font-family:inherit;'
    + 'font-size:14px;line-height:1.45;padding:13px 16px;text-align:center}'
    + '.mx-rec-tarja strong{font-weight:600}'
    + '.mx-rec-tarja span{opacity:.82;display:inline-block}'
    + '.mx-rec-box{margin:16px 0;padding:16px;border:1px solid #e3e3e3;'
    + 'border-radius:10px;background:#fafafa;font-family:inherit;'
    + 'color:#232323}'
    + '.mx-rec-topo{display:flex;align-items:center;gap:9px;'
    + 'margin-bottom:4px}'
    + '.mx-rec-topo svg{width:20px;height:20px;flex:0 0 20px;'
    + 'stroke:#111;fill:none;stroke-width:1.6;stroke-linecap:round;'
    + 'stroke-linejoin:round}'
    + '.mx-rec-topo strong{font-size:15px}'
    + '.mx-rec-sub{font-size:13px;color:#666;margin-bottom:12px}'
    + '.mx-rec-linha{display:flex;gap:8px;flex-wrap:wrap}'
    + '.mx-rec-linha input[type=email]{flex:1 1 200px;padding:11px 12px;'
    + 'border:1px solid #ddd;border-radius:8px;font-size:14px;'
    + 'font-family:inherit}'
    + '.mx-rec-linha button{padding:11px 20px;background:#111;color:#fff;'
    + 'border:0;border-radius:8px;cursor:pointer;font-size:14px;'
    + 'font-weight:600;font-family:inherit;white-space:nowrap}'
    + '.mx-rec-linha button:hover{opacity:.88}'
    + '.mx-rec-ok{background:#e8f5e9;border-color:#a5d6a7;color:#1b5e20;'
    + 'padding:13px;border-radius:8px;font-size:14px;margin:16px 0}'
    + '.mx-rec-nota{font-size:11px;color:#888;margin-top:9px}'
    + '.mx-rec-off{background:#eee!important;border-color:#ddd!important;'
    + 'color:#888!important;cursor:not-allowed!important;'
    + 'pointer-events:none!important;opacity:1!important}'
    + '@media (max-width:600px){.mx-rec-linha button{width:100%}}';

  function estilo() {
    if (document.getElementById('mx-rec-css')) return;
    var s = document.createElement('style');
    s.id = 'mx-rec-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function tarja() {
    if (document.querySelector('.mx-rec-tarja') || !document.body) return;
    var d = document.createElement('div');
    d.className = 'mx-rec-tarja';
    d.setAttribute('role', 'status');
    d.innerHTML = '<strong>' + TARJA + '</strong>'
      + (previa ? ' <span>(previa: só você está '
                  + 'vendo isto)</span>' : '');
    document.body.insertBefore(d, document.body.firstChild);
  }

  /* ⭐ o mesmo formulario do mx-avise: 'customer' nativo do Shopify,
     que CRIA O CLIENTE na lista de marketing com uma etiqueta.  Como
     aqui eu monto por JS, os campos que o Liquid geraria sozinho
     (form_type e utf8) vao escritos a mao. */
  function caixa(ondeTexto) {
    var d = document.createElement('div');
    d.className = 'mx-rec-box';
    d.setAttribute('data-mx-recesso', '1');
    d.innerHTML = ''
      + '<div class="mx-rec-topo">'
      + '<svg viewBox="0 0 24 24">'
      + '<path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9"/>'
      + '<path d="M13.7 21a2 2 0 01-3.4 0"/>'
      + '</svg><strong>Avisamos na volta</strong></div>'
      + '<div class="mx-rec-sub">' + ondeTexto + '</div>'
      + '<form method="post" action="/contact#contact_form"'
      + ' class="mx-rec-form" accept-charset="UTF-8">'
      + '<input type="hidden" name="form_type" value="customer">'
      + '<input type="hidden" name="utf8" value="✓">'
      + '<input type="hidden" name="customer[tags]" value="'
      + ETIQ + ', aviso-volta">'
      + '<input type="hidden" name="customer[accepts_marketing]"'
      + ' value="true">'
      + '<input type="hidden" name="contact[tags]" value="' + ETIQ + '">'
      + '<input type="hidden" name="customer[note]"'
      + ' value="Entrou durante o recesso de novembro/2026">'
      + '<div class="mx-rec-linha">'
      + '<input type="email" name="contact[email]"'
      + ' placeholder="seu@email.com" required autocomplete="email"'
      + ' aria-label="Seu e-mail">'
      + '<button type="submit">Quero ser avisado</button>'
      + '</div></form>'
      + '<div class="mx-rec-nota">Usamos seu e-mail só para este'
      + ' aviso e para novidades da MoxLand. Pode sair quando quiser.'
      + '</div>';
    return d;
  }

  function sucesso() {
    var d = document.createElement('div');
    d.className = 'mx-rec-ok';
    d.setAttribute('data-mx-recesso', '1');
    d.innerHTML = '<strong>Pronto!</strong> Vocé está na '
      + 'lista. Avisamos assim que a loja voltar, com as ofertas da '
      + 'Black Friday.';
    return d;
  }

  function mandou() {
    var q = window.location.search || '';
    return q.indexOf('customer_posted=true') >= 0
      || q.indexOf('contact_posted=true') >= 0;
  }

  function desligar(b) {
    if (!b || b.getAttribute('data-mx-rec-off')) return;
    b.setAttribute('data-mx-rec-off', '1');
    b.setAttribute('disabled', 'disabled');
    b.classList.add('mx-rec-off');
    if (b.tagName === 'BUTTON' || b.tagName === 'A') {
      b.textContent = BOTAO;
    } else if (b.tagName === 'INPUT') {
      b.value = BOTAO;
    }
  }

  function travarCompra() {
    var formas = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(formas, function (f) {
      if (!f.getAttribute('data-mx-rec')) {
        f.setAttribute('data-mx-rec', '1');
        f.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();
        }, true);
      }
      Array.prototype.forEach.call(
        f.querySelectorAll('[name=add], button[type=submit],'
          + ' input[type=submit], .button-cart, .add-to-cart'),
        desligar);
    });
    /* ⭐ Os botoes da COMPRA POR LISTA e dos cartoes de produto: na
       pagina /pages/compra-por-lista eles sao .product-form__submit e
       .button-ATC, com id product-add-to-cart-<variante>.  Medido na
       pagina viva em 31/10 — sem estes nomes, a lista continuava com
       botao aceso. */
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-action="add-to-cart"],'
        + ' .halo-productCardAction a, .product-card-action button,'
        + ' .product-form__submit, .button-ATC,'
        + ' [id^="product-add-to-cart"]'),
      desligar);
  }

  function travarCarrinho() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[name=checkout], .cart__checkout,'
        + ' .cart-checkout, a[href="/checkout"],'
        + ' a[href^="/checkout"], button[value="Finalizar"]'),
      desligar);
  }

  function ondeEntra() {
    return document.querySelector('form[action*="/cart/add"]')
      || document.querySelector('.cart__footer, .cart-footer,'
        + ' .cart__items, .productView-options');
  }

  function poeCaixa() {
    if (document.querySelector('[data-mx-recesso]')) return;
    /* ⭐ na carta esgotada o site ja' mostra o "Avise-me quando
       chegar".  Duas caixas de e-mail na mesma tela e' feio e confunde
       — deixo a do tema e fico so' com a tarja. */
    if (document.querySelector('[data-mx-avise]')) return;
    var alvo = ondeEntra();
    if (!alvo || !alvo.parentNode) return;
    var texto = 'Deixe seu e-mail e avisamos assim que a loja voltar, '
      + 'com as ofertas da Black Friday.';
    var bloco = mandou() ? sucesso() : caixa(texto);
    alvo.parentNode.insertBefore(bloco, alvo.nextSibling);
  }

  function varrer() {
    estilo();
    tarja();
    travarCompra();
    travarCarrinho();
    poeCaixa();
  }

  function comecar() {
    varrer();
    if (document.body) {
      /* o tema redesenha pedaco de pagina (carrinho ajax, quick view);
         entao eu volto a passar quando algo muda */
      var obs = new MutationObserver(function () {
        clearTimeout(window.__mxRecessoT);
        window.__mxRecessoT = setTimeout(varrer, 120);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', varrer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }
})();
/* fim mx-recesso */
